import { Component, createRef } from 'react';
import { INSBox } from './INSBox';
import { NSRepeater } from './NSRepeater';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import { NSTag, NSTagValue } from './NSTag';
import { INSBoxBaseLayoutProps } from './NSBoxBaseLayout';

export interface NSRepeaterNSTagProps extends IBaseComponentProps, INSBoxBaseLayoutProps<NSTag, NSTagValue>
{
	name: string;
	onItemChanged?: (repeater: NSRepeaterNSTag) => void;
	onValuesChanged?: (repeater: NSRepeaterNSTag) => void;
	required: boolean;
	min?: number;
	max?: number;
}

export class NSRepeaterNSTag extends Component<NSRepeaterNSTagProps> implements INSBox
{
	private Repeater_Refs = createRef<NSRepeater<NSTag, NSTagValue>>();
	constructor(props: NSRepeaterNSTagProps)
	{
		super(props);
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	isEmpty(): boolean
	{
		return this.Repeater_Refs.current?.isEmpty() ?? true;
	}
	getError(): string | null
	{
		return this.Repeater_Refs.current?.getError() ?? null;
	}
	getValue(checkError: boolean = true): NSTagValue[] 
	{
		return (this.Repeater_Refs.current?.getValue(checkError) ?? []).filter(x => x) as NSTagValue[];
	}
	setValue(value: NSTagValue[], callback?: () => void): void
	{
		this.Repeater_Refs.current?.setValue(value, callback);
	}
	override render()
	{
		return <NSRepeater<NSTag, NSTagValue>
			ref={this.Repeater_Refs}
			{...this.props}
			ignoreItemsHavingError
			createItem={(gIndex, lIndex, ref, onChange, onDelete) =>
			{
				return <NSTag
					key={`NSRepeaterNSTag_${this.props.name}_item_${gIndex}`}
					ref={ref}
					onChanged={() =>
					{
						onChange();
					}}
					onDeleted={() =>
					{
						onDelete?.(lIndex);
					}}
				/>;
			}}
			isEmpty={(_, value) => NSTag.isEmpty(value)}
			getValue={(item, checkError) => item.getValue(checkError)}
			setValue={(item, _, value) =>
			{
				item.setValue(value);
			}}
			onValuesChanged={() =>
			{
				this.props.onValuesChanged?.(this);
			}}
			onItemChanged={() =>
			{
				this.props.onItemChanged?.(this);
			}}
			style={{ width: "100%" }}
		/>;
	}
}